import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Homenew.css";
import Sidebarnew from "./Sidebarnew";
import Navigationnew from "./Navigationnew";
import api from "../../api/axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRef } from "react"; 

// ── Icon colors per agent index ──
const ICON_COLORS = [
  { bg: "#EEF2FF", color: "#4F46E5" },
  { bg: "#F5F3FF", color: "#7C3AED" },
  { bg: "#ECFDF5", color: "#059669" },
  { bg: "#FFF7ED", color: "#D97706" },
  { bg: "#EFF6FF", color: "#2563EB" },
  { bg: "#FEF2F2", color: "#DC2626" },
];

// ── SVG icons per agent index ──
function AgentIcon({ index, size = 22 }) {
  const icons = [
    // document
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
    </svg>,
    // star
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>,
    // users
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>,
    // activity
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
    </svg>,
    // bar chart
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
    </svg>,
    // cpu
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/>
    </svg>,
  ];
  return icons[index % icons.length];
}

function Homenew() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  // ── State ──
  const [loading, setLoading] = useState(true);
  const [agents, setAgents] = useState([]);           // all agents
  const [activeAgents, setActiveAgents] = useState([]); // sorted active
  const [draftAgents, setDraftAgents] = useState([]);   // draft agents
  const [isNewUser, setIsNewUser] = useState(false);

  // ── Chat input state ──
  const [message, setMessage] = useState("");
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [loggedInUserName, setLoggedInUserName] = useState("");
  const [artifactsOpen, setArtifactsOpen] =
  useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

useEffect(() => {
  api.get("/profile").then(res => {
    setLoggedInUserName(res.data?.name || "");
  }).catch(() => {});
}, []);
 
const [deleteConfirmGroup, setDeleteConfirmGroup] =
  useState(null);

  // ── Fetch agents + sort by last conversation ──
  useEffect(() => {
    const loadAgents = async () => {
      setLoading(true);
      try {
        const res = await api.get("/agents");
        const allAgents = res.data || [];

        if (!allAgents.length) {
          setIsNewUser(true);
          setLoading(false);
          return;
        }

        setIsNewUser(false);
        

        // Fetch last conversation time for each agent to sort by recency
        const agentsWithTime = await Promise.all(
          allAgents.map(async (agent) => {
            try {
              const convRes = await api.get(
                `/agents/${agent.id}/conversations?limit=1`
              );
              const convs =
                convRes.data?.conversations ||
                (Array.isArray(convRes.data) ? convRes.data : []);
              const lastTime =
                convs.length > 0
                  ? new Date(convs[0].created_at).getTime()
                  : 0;
              return { ...agent, _lastChatTime: lastTime };
            } catch {
              return { ...agent, _lastChatTime: 0 };
            }
          })
        );

        // Split into active (has docs) and draft (no docs)
        const active = agentsWithTime
          .filter(
            (a) =>
              a.status === "Active" ||
              parseInt(a.doc_count || 0) > 0
          )
          .sort((a, b) => b._lastChatTime - a._lastChatTime);

        const draft = agentsWithTime
          .filter(
            (a) =>
              a.status === "Draft" &&
              parseInt(a.doc_count || 0) === 0
          )
          .sort((a, b) => b._lastChatTime - a._lastChatTime);

       // ONLY latest 4 active chatted agents
const latest4ActiveAgents = active
  .filter((a) => a._lastChatTime > 0)
  .slice(0, 4);

setActiveAgents(latest4ActiveAgents);
        setAgents(agentsWithTime);

        // Pre-select the most recently chatted agent for the input pill
        const mostRecent = [...active, ...draft].sort(
          (a, b) => b._lastChatTime - a._lastChatTime
        )[0];
        if (mostRecent) setSelectedAgent(mostRecent);
      } catch (err) {
        console.error("Homenew loadAgents error:", err);
        setIsNewUser(true);
      } finally {
        setLoading(false);
      }
    };

    loadAgents();
  }, []);
//   useEffect(() => {
//   const handleEsc = (e) => {
//     if (e.key === "Escape") {
//       setShowAgentModal(false);
//     }
//   };

//   window.addEventListener("keydown", handleEsc);

//   return () =>
//     window.removeEventListener("keydown", handleEsc);
// }, []);
// useEffect(() => {
//   const handleOutsideClick = (e) => {
//     // clicked inside dropdown
//     if (
//       e.target.closest(".agent-dropdown-panel")
//     ) {
//       return;
//     }

//     // clicked on selector button
//     if (
//       e.target.closest(".chat-agent-select")
//     ) {
//       return;
//     }

//     // otherwise close
//     setShowAgentModal(false);
//   };

//   document.addEventListener(
//     "mousedown",
//     handleOutsideClick
//   );

//   return () => {
//     document.removeEventListener(
//       "mousedown",
//       handleOutsideClick
//     );
//   };
// }, []);

  // ── UPDATE: Navigate ONLY for drafts/errors, otherwise select agent ──
  const handleAgentClick = (agent) => {
    const isActive = agent.status === "Active" || parseInt(agent.doc_count || 0) > 0;
    
    if (!isActive) {
      toast.info("This is a draft category agent. In order to chat with it attach at least 1 document", {
        position: "top-center",
        autoClose: 4000,
        hideProgressBar: true,
      });
      return; // Stop here, don't navigate or select
    }

    // Set the selected agent to update Navbar & Sidebar
    setSelectedAgent(agent);
  };

  const remainingActiveAgents = agents.filter((agent) => {
  const isActive =
    agent.status === "Active" ||
    parseInt(agent.doc_count || 0) > 0;

  const alreadyVisible = activeAgents.some(
    (a) => a.id === agent.id
  );

  return isActive && !alreadyVisible;
});
 // Update handleSend to pass file via navigation state
// Update handleSend to pass file via navigation state safely
  const handleSend = () => {
    if (!message.trim() && !selectedFile) return;

    if (isNewUser || !selectedAgent) {
      toast.info("You don't have any agents to chat with", {
        position: "top-right",
        autoClose: 2400,
        hideProgressBar: true,
        closeButton: true,
        pauseOnHover: false,
        draggable: false,
        theme: "light",
        style: {
          minHeight: "46px",
          padding: "10px 14px",
          borderRadius: "12px",
          fontSize: "14px",
          fontWeight: 500,
          width: "340px",
          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        },
      });
      return;
    }

    // Fallback just in case selectedAgent is a string ID instead of an object
    const agentIdToPass = selectedAgent?.id || selectedAgent;

    navigate(`/chatinterface/${agentIdToPass}`, {
      state: {
        initialMessage: message,
        // selectedFile is already structured as { file, preview }
        initialFile: selectedFile, 
      },
    });
  };
  // ── Render a single agent row ──
  const AgentRow = ({ agent, idx }) => {
    const iconStyle = ICON_COLORS[idx % ICON_COLORS.length];
    const isActive =
      agent.status === "Active" || parseInt(agent.doc_count || 0) > 0;

    return (
      <div
        className={`hn-agent-row ${selectedAgent?.id === agent.id ? 'selected' : ''}`}
        onClick={() => handleAgentClick(agent)}
        style={{
          borderColor: selectedAgent?.id === agent.id ? '#3B82F6' : '#E5E7EB',
          backgroundColor: selectedAgent?.id === agent.id ? '#F5F8FF' : '#FFFFFF'
        }}
      >
        {/* Icon */}
        <div
          className="hn-agent-row-icon"
          style={{ background: iconStyle.bg, color: iconStyle.color }}
        >
          <AgentIcon index={idx} size={20} />
        </div>

        {/* Info */}
        <div className="hn-agent-row-info">
          <div className="hn-agent-row-name-line">
            <span className="hn-agent-row-name">{agent.name}</span>
            <span
              className={`hn-agent-pill ${isActive ? "active" : "draft"}`}
            >
              {isActive ? "Active" : "Draft"}
            </span>
          </div>
          <p className="hn-agent-row-desc">
            {agent.description || "AI-powered assistant"}
          </p>
        </div>

        {/* Model + chevron */}
        <div className="hn-agent-row-right">
          <span className="hn-agent-row-model">
            {agent.model || "ChatGPT 4.0"}
          </span>
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#9CA3AF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </div>
      </div>
    );
  };

  // ============================================================
  // RENDER
  // ============================================================
  const currentHour = new Date().getHours();

let greeting = "Good Evening";

if (currentHour < 12) {
  greeting = "Good Morning";
} else if (currentHour < 17) {
  greeting = "Good Afternoon";
}
  return (
    <div className="homenew-layout">
     
      
      {/* Pass the currently selected agent to sync the Sidebar */}
    <Sidebarnew
  selectedAgent={selectedAgent}
  deleteConfirmGroup={deleteConfirmGroup}
  setDeleteConfirmGroup={setDeleteConfirmGroup}
/>

      <div className="homenew-main">
        {/* Pass the currently selected agent to sync the Navbar */}
 <Navigationnew
  selectedAgent={selectedAgent}
  setSelectedAgent={setSelectedAgent}
  remainingActiveAgents={remainingActiveAgents}
  artifactsOpen={artifactsOpen}
  setArtifactsOpen={setArtifactsOpen}
/>

        <div className="homenew-content">
          {loading ? (
            <div className="hn-loading">
              <div className="hn-spinner"></div>
            </div>
          ) : isNewUser ? (
            /* ════════════════════════════════════════
               NEW USER — Welcome screen
            ════════════════════════════════════════ */
            <>
              {/* Logo */}
          <div className="homenew-greeting homenew-greeting-newuser">

  <img
    src="/images/Xlogo.svg"
    alt="logo"
    className="homenew-logo"
  />

  <h1 className="homenew-greeting-text">
  {greeting}{loggedInUserName ? `, ${loggedInUserName}` : ""}
</h1>

</div>

              {/* Title */}
              <h1 className="homenew-title">Welcome to KINEXAR AI</h1>

              {/* Subtitle */}
              <p className="homenew-subtitle">
                You haven't created any agents yet. Try the sample{" "}
                <span>KINEXAR Guide</span> agent below to see how it works,
                or build your first agent.
              </p>

              {/* 4 Action Cards */}
              <div className="homenew-grid">
                <div
                  className="homenew-card"
                 onClick={() => navigate("/home")}
                >
                  <div className="homenew-icon blue">
                    <img src="/images/Createnewag.svg" alt="create" />
                  </div>
                  <div>
                    <h3>Create Agent</h3>
                    <p>Configure a new AI agent</p>
                  </div>
                </div>

                <div
                  className="homenew-card"
                  onClick={() => navigate("/kb")}
                >
                  <div className="homenew-icon purple">
                    <img src="/images/Uploadnew.svg" alt="upload" />
                  </div>
                  <div>
                    <h3>Upload Knowledge</h3>
                    <p>Add documents to KB</p>
                  </div>
                </div>

                <div
                  className="homenew-card"
                  onClick={() => navigate("/analytics")}
                >
                  <div className="homenew-icon green">
                    <img src="/images/Viewnewlyics.svg" alt="analytics" />
                  </div>
                  <div>
                    <h3>View Analytics</h3>
                    <p>See performance metrics</p>
                  </div>
                </div>

                <div
                  className="homenew-card"
                  onClick={() => navigate("/dashboard")}
                >
                  <div className="homenew-icon yellow">
                    <img src="/images/Dashnew.svg" alt="dashboard" />
                  </div>
                  <div>
                    <h3>Dashboard</h3>
                    <p>Overview of all activity</p>
                  </div>
                </div>
              </div>

              {/* KINEXAR Guide card */}
              <div className="guide-card">
                <div className="guide-left">
                <div className="guide-icon">
  <img
    src="/images/welcmthunder.svg"
    alt="guide"
  />
</div>
                  <div className="guide-content">
                    <div className="guide-top">
                      <h3>KINEXAR Guide</h3>
                      <span>Sample</span>
                    </div>
                    <p>
                      Your interactive onboarding assistant. Ask how to create
                      agents, upload documents, or read analytics.
                    </p>
                  </div>
                </div>
                <button
                  className="guide-btn"
                  onClick={() => navigate("/create-agent")}
                >
                  Try it →
                </button>
              </div>

              {/* "I've used this before" link */}
              <div
                className="homenew-link"
                onClick={() => navigate("/myagents")}
              >
                I've used this before — show my agents
              </div>
            </>
          ) : (
            /* ════════════════════════════════════════
               OLD USER — Agent list screen
            ════════════════════════════════════════ */
            <>
              {/* X logo */}
<div className="homenew-greeting">

  <img
    src="/images/Xlogo.svg"
    alt="logo"
    className="homenew-logo"
  />

 <h1 className="homenew-greeting-text">
  {greeting}{loggedInUserName ? `, ${loggedInUserName}` : ""}
</h1>

</div>
              {/* Most recently chatted agent headline */}
              {/* {selectedAgent && (
                <>
                  <h1 className="hn-agent-headline">{selectedAgent.name}</h1>
                  <p className="hn-agent-subline">
                    {selectedAgent.description || "AI-powered assistant"}
                  </p>
                </>
              )} */}

              {/* Agent list panel */}
              <div className="hn-agents-panel">
                <div className="hn-agents-label">YOUR AGENTS</div>

                {/* Active agents */}
                {activeAgents.map((agent, idx) => (
                  <AgentRow key={agent.id} agent={agent} idx={idx} />
                ))}

                {/* Draft agents — shown after active, no separator band */}
                {/* {draftAgents.map((agent, idx) => (
                  <AgentRow
                    key={agent.id}
                    agent={agent}
                    idx={activeAgents.length + idx}
                  />
                ))} */}

                {/* Add New Agent dashed button */}
                <button
                  className="hn-add-agent-btn"
                  onClick={() => navigate("/create-agent")}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                  </svg>
                  Add New Agent
                </button>
              </div>
            </>
          )}

          {/* ── Chat input (shared, always shown) ── */}
    {/* ───────────────── CHAT SECTION ───────────────── */}

<div className={`chatbox-area ${isNewUser ? 'chatbox-new-user' : 'chatbox-old-user'}`}>
  {/* MAIN CHATBOX */}
 
 {/* MAIN CHATBOX */}
  <div className="chatbox-wrapper" style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'flex-end', /* Pushes everything to the bottom of the tall box */
    padding: '16px', 
    minHeight: '112px' /* Restores the original spacious height! */
  }}>
    
    {/* ✅ ATTACHMENT PILL (Sits above the input row) */}
    {selectedFile && (
      <div style={{
        display: "flex", alignItems: "center", gap: "8px", 
        background: "#F3F4F6", padding: "6px 12px", 
        borderRadius: "8px", width: "fit-content", 
        border: "1px solid #E5E7EB", marginBottom: "12px"
      }}>
        <span style={{ fontSize: "13px", color: "#374151", fontWeight: "500" }}>
          📎 {selectedFile.file.name}
        </span>
        <button 
          onClick={() => setSelectedFile(null)}
          style={{
            background: "none", border: "none", color: "#9CA3AF", 
            cursor: "pointer", padding: "0", display: "flex", alignItems: "center"
          }}
          title="Remove attachment"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    )}

    {/* ✅ SINGLE ROW LAYOUT: [Attach] -> [Text] -> [Send] */}
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
      
      {/* ATTACH BUTTON (Transparent background to match Chat Interface) */}
      <button 
        title="Attach" 
        onClick={() => fileInputRef.current.click()} 
        style={{ 
          background: 'transparent', border: 'none', cursor: 'pointer', 
          padding: 0, display: 'flex', alignItems: 'center', flexShrink: 0 
        }}
      >
        <img src="/images/cloudattach.svg" alt="attach" style={{ width: '22px', height: '22px' }} />
      </button>

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (!file) return;
          
          setSelectedFile({
            file,
            preview: file.type && file.type.startsWith("image/") ? URL.createObjectURL(file) : null,
          });
        }}
      />

      {/* ✅ TEXT INPUT (Changed to input type="text" for perfect vertical centering) */}
      <input
        type="text"
        placeholder={
          selectedFile
            ? ""
            : selectedAgent
            ? `Message ${selectedAgent.name}...`
            : "How do I create my first agent?"
        }
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleSend();
        }}
        style={{
          flex: 1,
          border: "none",
          background: "transparent",
          outline: "none",
          fontSize: "15px",
          color: "#1f1f1f",
          padding: "0",
          margin: 0,
          height: "24px"
        }}
      />

      {/* ✅ SEND BUTTON (Matches the exact styling and blue colors from ChatInterface) */}
      <button
        onClick={handleSend}
        disabled={!message.trim() && !selectedFile}
        style={{
          width: "34px",
          height: "34px",
          borderRadius: "10px",
          background: (message.trim() || selectedFile) ? "#2563EB" : "#BFDBFE",
          border: "none",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: (message.trim() || selectedFile) ? "pointer" : "not-allowed",
          transition: "background 0.2s ease",
          flexShrink: 0,
          margin: 0
        }}
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="22" y1="2" x2="11" y2="13" />
          <polygon points="22 2 15 22 11 13 2 9 22 2" />
        </svg>
      </button>
    </div>
  </div>

  {/* ───────────────── FLOATING DROPDOWN ───────────────── */}

 

</div>

{/* FOOTER */}
<p className="footer-text">
  Kinexar AI can make mistakes. Verify important information.
</p>

         
        </div>
      </div>
      {deleteConfirmGroup && (
  <div className="sidebarnew-delete-overlay">

    <div className="sidebarnew-delete-modal">

      <h3>Delete Chat?</h3>

      <p>
        This conversation will be permanently removed.
      </p>

      <div className="sidebarnew-delete-actions">

        <button
          className="cancel"
          onClick={() =>
            setDeleteConfirmGroup(null)
          }
        >
          Cancel
        </button>

        <button
          className="delete"
          onClick={() => {
            if (
              window.handleDeleteChatFromSidebar
            ) {
              window.handleDeleteChatFromSidebar(
                deleteConfirmGroup.session_id
              );
            }

            setDeleteConfirmGroup(null);
          }}
        >
          Delete
        </button>

      </div>

    </div>

  </div>
)}

    </div>
  );
}

export default Homenew;